import Swiper, { EffectFade, Autoplay } from 'swiper';
import '../../../../node_modules/swiper/modules/effect-fade/effect-fade.scss';
import { updateMap, controlMapZoom } from '../helpers/maps';
import { resetLocationFilters } from '../helpers/locations';
import { playPauseVideo } from '../helpers/video.js';
import { updateActiveRegions } from '../functions/location-filters.js';

Swiper.use([EffectFade, Autoplay]);

export const heroLs = () => {
	const heroLsModules = document.querySelectorAll('.m__hero-ls');

	if (heroLsModules) {
		heroLsModules.forEach(mod => {
			const mapElem = mod.querySelector('.js-loc-search-map');
			const resultsContainer = mod.querySelector('.js-loc-search-results-container');

			// Initialise the slider
			initHeroLsSlider(mod.querySelector('.m__hero-ls-swiper'));

			// Init the view trigger functionality
			const viewTriggers = mod.querySelectorAll('.js-hero-ls-view-trigger');

			if ( viewTriggers ) {
				viewTriggers.forEach(trigger => {
					trigger.addEventListener('click', () => {
						// only run if the trigger is not already active
						if ( !trigger.classList.contains('active') ) {
							// remove active class from all triggers
							viewTriggers.forEach(t => {
								t.classList.remove('active');
							});

							// add active class to the clicked trigger
							trigger.classList.add('active');

							// Set the minHeight of the results container to the current height
							resultsContainer.style.minHeight = resultsContainer.clientHeight + 'px';

							// get the view type from the trigger
							const viewType = trigger.dataset.view;
							const elemToHide = viewType === 'map' ? resultsContainer.querySelector('.js-loc-search-results-grid') : resultsContainer.querySelector('.js-loc-search-results-map');
							const elemToShow = viewType === 'map' ? resultsContainer.querySelector('.js-loc-search-results-map') : resultsContainer.querySelector('.js-loc-search-results-grid');

							if ( viewType === 'map' ) {
								// Update the map
								updateMap(mapElem);
							}

							// hide the current view
							elemToHide.classList.add('hidden');

							// show the new view
							elemToShow.classList.remove('hidden');

							// remove the minHeight from the results container
							resultsContainer.style.minHeight = 'auto';
						}
					});
				});
			}

			// Run accordion JS
            const regionTriggers = mod.querySelectorAll('.js-loc-search-map-region-trigger');
        
            if ( regionTriggers ) {
                regionTriggers.forEach(trigger => {
                    trigger.addEventListener('click', (e) => {
                        e.preventDefault();
                        const regions = trigger.closest('.e__locations__regions').querySelectorAll('.js-loc-search-map-region');
                        const regionOpen = trigger.classList.contains('active');
        
                        // Close all regions
                        closeAllRegions(regions, mapElem, resultsContainer);
        
                        // Open clicked region if not already open
                        if ( !regionOpen ) {
                            openRegion(trigger, mapElem, resultsContainer);
                        }
                    });
                });
            }

			// Run the reset button functionality
			resetLocationFilters(mod);

			// Run the custom zoom buttons
			const customZoomButtons = mod.querySelectorAll('.e__locations__map__zoom');
			if ( customZoomButtons ) {
				customZoomButtons.forEach(button => {
					button.addEventListener('click', (event) => {
						event.preventDefault();
						controlMapZoom(mapElem, button.dataset.zoomType);
					});
				});
			}
		});
	}
}

const initHeroLsSlider = (slider) => {
	if ( slider ) {
		const sliderSlides = slider.querySelectorAll('.m__hero-ls-swiper-slide');

		// Check if the first slide contains a video and if so play the video
		const initSlide = sliderSlides[0];
		const initSlideVideo = initSlide.querySelector('.js__hero-ls-swiper-video'); 

		if ( initSlideVideo ) {
			initSlideVideo.play();
		}

		// Loop through each slide and initialise the playPuase functionality
		sliderSlides.forEach(slide => {
			const video = slide.querySelector('.js__hero-ls-swiper-video');
			const videoControls = slide.querySelector('.js-video-controls');
	
			if ( video && videoControls ) {
				playPauseVideo(video, videoControls);
			}
		});

		if (sliderSlides.length > 1) {
			// Initialise the slider
			const heroLsSwiper = new Swiper(slider, {
				centeredSlides: true,
				slidesPerView: 1,
				effect: "fade",
				speed: 1500,
				fadeEffect: {
					crossFade: true
				},
				autoplay: {
					delay: 3000,
					disableOnInteraction: true,
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
			});

			heroLsSwiper.on('slideChange', function () {
				// If the previous slide contains a video then pause the video
				const prevSlideVideo = heroLsSwiper.slides[heroLsSwiper.previousIndex].querySelector('.js__hero-ls-swiper-video');

				if ( prevSlideVideo ) {
					prevSlideVideo.pause();
				}

				// Check if the current slide contains a video
				const currentSlide = heroLsSwiper.slides[heroLsSwiper.activeIndex];
				const currentSlideVideo = currentSlide.querySelector('.js__hero-ls-swiper-video');
				const currentSlideVideoControls = currentSlide.querySelector('.js-video-controls');

				if ( currentSlideVideo && currentSlideVideoControls ) {
					// If the play icon is hidden this means that the video hasn't been paused before changing slides so play the video
					const playIcon = currentSlideVideoControls.querySelector('.e__video-controls-image--play');

					if ( playIcon && playIcon.classList.contains('hidden') ) {
						currentSlideVideo.play();
					}
				}
			});
		}
	}
}

const closeAllRegions = (regions, mapElem, resultsContainer) => {
    if ( regions ) {
        regions.forEach(region => {
            // Reset all triggers
            const regionTriggers = region.querySelectorAll('.js-loc-search-map-region-trigger');
            if ( regionTriggers ) {
                regionTriggers.forEach(trigger => {
                    trigger.classList.remove('active');
    
                    const arrow = trigger.querySelector('svg');
                    arrow.classList.remove('-scale-y-100');
                });
            }
            
            // Close all regions content elems
            const regionsContent = region.querySelectorAll('.js-loc-search-map-region-content');
            if ( regionsContent ) {
                regionsContent.forEach(region => {
                    region.classList.add('hidden');
                });
            }
        });
    }
	
	updateActiveRegions([], resultsContainer);
	updateMap(mapElem);
}

const openRegion = (trigger, mapElem, resultsContainer) => {
    const region = trigger.closest('.js-loc-search-map-region');

    if ( region ) {
        // Set clicked trigger as active
        trigger.classList.add('active');

        const arrow = trigger.querySelector('svg');
        arrow.classList.add('-scale-y-100');

        // Show the clicked region content
        const regionContent = region.querySelector('.js-loc-search-map-region-content');
        if ( regionContent ) {
            regionContent.classList.remove('hidden');
        }
    }

	updateActiveRegions([{value: region.dataset.regionId}], resultsContainer);
	updateMap(mapElem);
}